import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanyService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Company_CompanyConfigurationDto,
} from '../../services/wealthlane-award-services';

const useGetTransactionConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Company_CompanyConfigurationDto | undefined,
  unknown
> => {
  const transactionConfiguration = useQuery(['getTransactionConfiguration'], async () => {
    return await handleRequest(CompanyService.getApiAwardApiAppCompanyCompanyConfiguration());
  });

  return transactionConfiguration;
};

export default useGetTransactionConfiguration;
